export default __webpack_public_path__ + "static/proxima-nova-100-a9afeb1658723e8d6a0bb8ae61815769.woff2";